import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import type { HomepageLayout } from '@news-cms/shared';
import { ApiError, api } from './api';

/** Current layout — drives the /homepage editor's initial state. */
export const homepageLayoutQueryOptions = queryOptions({
  queryKey: ['homepage', 'layout'] as const,
  queryFn: () =>
    api<{ layout: HomepageLayout }>('/api/admin/homepage/layout').then((d) => d.layout),
  staleTime: 30_000,
});

/** PATCH the full layout. Backend validates groupSlug refs + bumps the
 *  pub:homepage cache version. */
export function useUpdateHomepageLayout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (layout: HomepageLayout) =>
      api<{ layout: HomepageLayout }>('/api/admin/homepage/layout', {
        method: 'PATCH',
        body: JSON.stringify(layout),
      }).then((d) => d.layout),
    onSuccess: (layout) => {
      qc.setQueryData(homepageLayoutQueryOptions.queryKey, layout);
    },
  });
}

export function homepageErrorMessage(e: unknown): string {
  if (!(e instanceof ApiError)) return 'เกิดข้อผิดพลาด กรุณาลองใหม่';
  switch (e.code) {
    case 'VALIDATION_ERROR':
      return 'layout ไม่ถูกต้อง — เช็คว่า groupSlug ทุก slot มีอยู่จริง';
    case 'FORBIDDEN':
      return 'ไม่มีสิทธิ์ — ต้องมี settings.update';
    default:
      return e.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่';
  }
}
